
    import { Variables } from "../../../variables";
    import { Component, Vue } from "vue-property-decorator";
    import { accountApi } from "../../services/api/account/account";
    import PanamaLayout from "../../layouts/PanamaLayout.vue";
    import { ForgotPasswordFacialRecognitionUpdateCommand } from "../../services/api/models/ForgotPasswordFacialRecognitionUpdateCommand.model";
    import FaceDetector from "../../components/FaceDetector.vue";

    @Component({
        components: { PanamaLayout, FaceDetector },
    })
    export default class ForgotPasswordPin extends Vue {

    get secretEncryptData() {
        return Variables.SecretEncryptData;
        }

        private step = 1;
        private pin = "";
        private documentation = "";
        private password = "";
        private repeatPassword = "";
        private errorMessage = "";
        private isErrorMessageShow = false;
        private isIdentificationLoading = false;
        private showIdentificationRequiredError = false;
        private isValidationLoading = false;
        private isPersonalInfoLoading = false;
        private showPassword = false;
        private facePhoto = "";
        private modalFaceDetector = false;
        private validBiometric = "";
        $route: any;
        $t: any;

        async mounted() {
            this.documentation = this.$route.params.documentationId ?? "";
        }

        showError(error: string) {
            this.errorMessage = error;
            this.isErrorMessageShow = true;
            setTimeout(() => (this.isErrorMessageShow = false), 8000);
        }

        previous() {
            this.step--;
        }

        async nextIdentification() {
            this.isIdentificationLoading = true;
            this.modalFaceDetector = false;

            if (this.documentation === "" || this.documentation === "") {
                this.showError("Rellene los campos obligatorios.");
                this.showIdentificationRequiredError = true;
                this.isIdentificationLoading = false;
                return;
            }

            this.step = 2;
            this.isIdentificationLoading = false;
            this.modalFaceDetector = true;
        }

        async nextValidation() {
            this.isValidationLoading = true;

            if (this.documentation === "" || this.facePhoto === "") {
                this.showError("Identificación y reconocimiento son obligatorios.");
                this.showIdentificationRequiredError = true;
                this.isValidationLoading = false;
                return;
            }

            this.step = 3;
            this.isValidationLoading = false;
        }

        async nextPersonalInfo() {
            this.isPersonalInfoLoading = true;

            if (this.documentation === "" || this.facePhoto === "") {
                this.showError("Identificación y reconocimiento son obligatorios.");
                this.showIdentificationRequiredError = true;
                this.isValidationLoading = false;
                return;
            }

            if (this.password === "" || this.repeatPassword === "") {
                this.showError("Rellene los campos obligatorios.");
                this.isPersonalInfoLoading = false;
                return;
            }

            if (this.password !== this.repeatPassword) {
                this.showError("Las contraseñas deben coincidir");
                this.isPersonalInfoLoading = false;
                return;
            }

            try {
                this.validBiometric = this.encryptData(
                    `${this.facePhoto}`,
                `${this.secretEncryptData}`
                );
                await accountApi.forgotPasswordFacialRecognition(
                    new ForgotPasswordFacialRecognitionUpdateCommand(
                        this.documentation,
                        this.password,
                        this.repeatPassword,
                        this.validBiometric
                    )
                );
                this.step = 4;
            } catch (err) {
                if (err.response.status === 400 && err.response.data) {
                    this.showError(err.response.data);
                    return;
                }
                this.showError(
                    "Ha surgido algún error durante la validación los datos. Intentelo de nuevo ó más tarde."
                );
            } finally {
                this.isPersonalInfoLoading = false;
            }
        }

        encryptData(data: string, key: string): string {
            let encryptedData = "";
            for (let i = 0; i < data.length; i++) {
                const charCodeData = data.charCodeAt(i);
                const charCodeKey = key.charCodeAt(i % key.length);
                const encryptedCharCode = charCodeData ^ charCodeKey;
                encryptedData += String.fromCharCode(encryptedCharCode);
            }
            return btoa(encryptedData);
        }

        photoTaken(isPhotoTaken: any, image: any) {
            this.modalFaceDetector = !isPhotoTaken;
            this.facePhoto = image;
            this.nextValidation();
        }
    }
